export const AdsHandlerActionTypes = {
  ADS_HANDLER_PAGES_REQUEST: 'ADS_HANDLER_PAGES_REQUEST',
  ADS_HANDLER_PAGES_SUCCESS: 'ADS_HANDLER_PAGES_SUCCESS',
  ADS_HANDLER_PAGES_FAILURE: 'ADS_HANDLER_PAGES_FAILURE',
  ADS_HANDLER_DRAFTS_REQUEST: 'ADS_HANDLER_DRAFTS_REQUEST',
  ADS_HANDLER_DRAFTS_SUCCESS: 'ADS_HANDLER_DRAFTS_SUCCESS',
  ADS_HANDLER_DRAFTS_FAILURE: 'ADS_HANDLER_DRAFTS_FAILURE',
};
